import dataBloedNietErnstigTAR from "../../../../src/data/niet-ernstige-bloedingen-onder-tar.json";
import BasicSchematic from "../../../../src/components/chart/interaction/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  dataBloedNietErnstigTAR,
  BasicSchematic,
  React
};